module.exports = __webpack_public_path__ + "img/368276canarias7.8d09b99d.jpg";